import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';

export const loadPublicRoute = () => returnAction(ActionEnum.LOAD_PUBLIC_ROUTE);
